export default {
    brand_name: '巧应试'
}